
<script>

  import func from "../../libs/functions.js";
  //import { StripeCheckout } from 'vue-stripe'

  import {
    mapGetters,
    mapState,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import _system from '../../libs/system';

   import VueSlider from 'vue-slider-component'
   import 'vue-slider-component/theme/default.css'

   import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';
   import system from '../../libs/system';

   const StripeCheckout = window.StripeCheckout;

   window.plans = [];

   export default {
   name: "UpgradeV2",
   components: {
    VueSlider
  },
   data() {
      return {
         channelPlanQuantity:1,
         handler: {},
         purchases: [],
         allPurchases: [],
         total: {},
         StripeCheckout:StripeCheckout,
         loading: {
            open: false
         },
         isLtd: false,
         limitexceed: false,
         allActiveAccounts: '',
         totalLimits2: '',
         pricingInterval: 'year',
         socialChannelPrice: 7,
         teamMemberPrice: 15,
         teamMemberCount: 1,
         socialChannelCount: 1,
         upgraded: false,
         teamSize: 1,
         couponCode: '',
         couponPercentage: 0,
         couponObject: {},
         couponActivated: false,
         plans:{},
         features: {},
         activePeriod: 'an'
      }
   },
   computed: {
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('workspaceusers', ['workspaceusers']),
   ...mapGetters('accounts', ['accounts']),
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('subscriptions', ['getPaypalSubscriptions', 'getSubscriptions']),
   ...mapGetters('plans', ['getPlans']),
      trialChecker(){
      let diff = (Math.floor(Date.now()) - this.getUser.createdAt);
         if(this.currentWorkspace.pricingPlan == 'Trial' && diff >= 1209600000){
         setTimeout(() => {
               this.setUpgradeModal(true)
         }, 20000);
         return true
         }else{
            return false
         }
      },
      totalLimits(){
         this.total.price = this.amountCutter(_.sumBy(this.allPurchases, 'amount'));
         this.total.users = _.sumBy(this.allPurchases, 'userLimit');
         this.total.channels = _.sumBy(this.allPurchases, 'channelLimit');

         return this.total
      }
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("htmlModals", ["setUpgradeModal"]),
   ...mapActions('tags', ['setTags']),
   ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
   ...mapActions('workspaceusers', ['setWorkspaceusers']),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
      amountCutter(amount){
         if(amount.length > 3){
            return amount.toString().slice(0, amount.toString().length -2 )
         }else{
            return amount
         }
         
      },
      closeModal(){
         document.body.classList.remove('overflowYHidden');
         this.setUpgradeModal(false);
      },
      tryCoupon(){
         let payload = {
            query: {
               couponCode: this.couponCode
            }
         }
         _system.services.stripe.checkCoupon(payload, (err, couponObject) => {
            if(err) return iziToast.error({ title: 'Noooo! 😿' });

            iziToast.success({
               position: 'bottomCenter',
               title: 'Discount Applied! Yaaaaayyyy! 🎉'
            });

            this.plans['an'] = _.map(this.plans['an'], (plan) => {
               console.log(plan)
               plan.metadata.price = '$' + (plan.metadata.price.substring(1) - (plan.metadata.price.substring(1) * couponObject.percent_off / 100))
               plan.amount = Math.floor((plan.amount - (plan.amount * couponObject.percent_off / 100)))
               return plan
            })

            this.plans['mo'] = _.map(this.plans['mo'], (plan) => {
               plan.metadata.price = '$' + (plan.metadata.price.substring(1) - (plan.metadata.price.substring(1) * couponObject.percent_off / 100))
               plan.amount = Math.floor((plan.amount - (plan.amount * couponObject.percent_off / 100)))
               return plan
            })

            this.couponCode = ''
            this.couponObject = couponObject

            this.couponActivated = true;
         });
      },
      open(plan, quantity){
         //pk_test_ESdTL2pe5FB5ypsvZ0obEceO
         //pk_live_IVNhGZ7zbbZLFLHRDz4SMOL8
         this.loading.open = true;
         var token_triggered = false;
         this.handler = this.StripeCheckout.configure({ 
            key: 'pk_live_IVNhGZ7zbbZLFLHRDz4SMOL8',
            closed: () => {
               if (!token_triggered) {
                  // close button click behavior goes here
                  this.loading.open = false;
               } else {
                  // payment completion behavior goes here
                  this.upgraded = true
               }
            },
            token: (token) => {

               token_triggered = true;

                  let payload = {
                     body: {
                        tokenId : token.id
                     },
                     query: {
                        userId: this.getUser._id
                     }
                  }

                  if(this.$router.history.current.fullPath.includes('test')){
                     payload.query.mode = 'testmode'
                     //+ '&mode=' + payload.query.mode
                  }

                  _system.services.stripe.createCustomer(payload, (err, newCustomer) => {

                  payload = {
                     body: {
                        items: [{
                           price: plan.id,
                           quantity: quantity
                        }],
                        customer: this.getUser._id
                     }
                  }

                     if(this.couponObject.id) {
                        payload.body.coupon = {"id": this.couponObject.id }
                     }

                     _system.services.stripe.createSubscription(payload, (err, subscription) => {
                        if(err){
                           console.log(err)
                            return alert(err.data.message)
                        }
                        alert('Payment succeed, just refresh your browser and check your billing section to confirm your purchase.')
                        window.ga('send', 'event', 'Func', 'Pricing', 'Paid', 1);
                        window.fbq('track', 'Subscribe', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
                        window.gtag('event', 'conversion', {'send_to': 'AW-10862805758/3eJgCPyQw7sDEP6F5bso'});
                     });

                  });

               } 
            });




         this.handler.open({
            name: 'Juphy, Inc.',
            description: plan.metadata.name,
            amount: plan.amount * quantity,
            email: this.getUser.email
         });


      },
      adjustTeamSize(up){
         if(up){
            this.teamSize += 1;
         }else{
            this.teamSize -= 1;
         }
      },
      onlyActiveAccounts(){
         return _.filter(this.accounts, (account) => {
              if(account.tags && account.tags.indexOf(this.tagsByName['Passive']._id) == -1 || !account.tags) return account;
            });
      }
   },
   mounted(){

      this.teamSize = this.workspaceusers.length

      //Burada adamın active accountslarını say ona göre engelle
         this.allPurchases = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()
         this.allPurchases = this.allPurchases.concat(this.getSubscriptions)
         let allActiveAccounts = _.filter(this.accounts, (a) => {
         if(a.tags && !a.tags.includes(this.tagsByName['Passive']._id)){
            return a
         }
         })
         let totalChannelLimit = _.sumBy(this.allPurchases, 'channelLimit')
         this.allActiveAccounts = allActiveAccounts.length;
         this.totalLimits2 = totalChannelLimit
         if(allActiveAccounts.length > totalChannelLimit){
            this.limitexceed = true;
         /*      setInterval(() => {
               $('#allert').transition('pulse');
            }, 1500) */
         }

   },
   created(){


      let purchases = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()
      purchases = purchases.concat(this.getSubscriptions)

      let ltdPackages = _.filter(purchases, (purchase) =>{
         if(purchase.package && (purchase.package == 'AppSumo' || purchase.package == 'Porthos'  || purchase.package == 'Aramis')) {
            return true
         }
      })

      if(ltdPackages.length) this.isLtd = true


      
      let mainPlans = _(_.filter(this.getPlans, (plan) => (plan.metadata.name == 'Starter' || plan.metadata.name == 'Growth')).map((plan) => {
            plan.metadata.price = '$' + ((plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2))
            plan.metadata.priceLean = ((plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2))
            plan.metadata.period = ((plan.interval == 'year') ? 'year' : 'mo')
            plan.metadata.desc = "Per month"
            return plan
         })).orderBy(['amount'], ['asc']).value()

         console.log(mainPlans)

         let upgradeChannels = _(_.filter(this.getPlans, { metadata: { name: 'Extra Channel +10' } })).map(plan => {
            plan.metadata.price = (plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)
            return plan;
         }).value()

         let whiteLabelUnlimited = _(_.filter(this.getPlans, { metadata: { identity: 'white_label_unlimited' } })).map(plan => {
            plan.metadata.price = (plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)
            return plan;
         }).value()

         let whiteLabelPerWorkspace = _(_.filter(this.getPlans, { metadata: { identity: 'white_label_per_workspace' } })).map(plan => {
            plan.metadata.price = (plan.interval == 'year') ? (Math.floor(plan.amount.toString().slice(0,-2) / 12)) : plan.amount.toString().slice(0,-2)
            return plan;
         }).value()

      this.plans = {
         an: _.filter(mainPlans, {interval: 'year'}),
         mo: _.filter(mainPlans, {interval: 'month'}),
         upgradeChannels: {
            an: _.filter(upgradeChannels, {interval: 'year'}),
            mo: _.filter(upgradeChannels, {interval: 'month'})
         },
         addons: {
            whiteLabel: {
               unlimited: {
                  mo: _.filter(whiteLabelUnlimited, {interval: 'month'})
               },
               perWorkspace: {
                  mo: _.filter(whiteLabelPerWorkspace, {interval: 'month'})
               }
            }
         }
      }



      this.features = [{
         id: 1,
         name: 'Channels',
         data: [
            'Up to 5',
            'Up to 10'
            ]
      },{
         id: 3,
         name: 'Data History',
         data: [
            '6 Months',
            'Unlimited'
            ]
      },{
         id: 4,
         name: 'Team Collaboration',
         //desc: 'Create seperated external teams to manage your clients. Agency specific feature.',
         data: [
            '<i class="check teal icon"></i>',
            '<i class="check teal icon"></i>'
            ]
      },{
         id: 5,
         name: 'All Core Features',
         data: [
            '<i class="check teal icon"></i>',
            '<i class="check teal icon"></i>'
            ]
      },{
         id: 6,
         name: 'Ads Comments',
         data: [
            '<i class="x grey icon"></i>',
            '<i class="check teal icon"></i>'
            ]
      }]
   }
}

</script>

<template>

  
   <div class="ui grid">

   <div style="background: #f5f5f5; border-radius: 0.5rem;" class="sixteen wide column">
      <div v-if="limitexceed" class="ui basic huge center aligned segment">
         <p id="allert">
            Your max channels limit is  <b style="color: #ff0000;">{{totalLimits2}}</b> but you have <b style="color: #ff0000;">{{allActiveAccounts}}</b> active channels, you have to upgrade your plan.
         </p>
      </div>
   <div class="ui basic segment">
      <table style="border: none;" class="ui celled large padded structured table">
         <thead>
           <tr>
         <th style="text-align: center;">
            <div class="ui small basic buttons">
               <button @click="activePeriod = 'mo'" :class="(activePeriod == 'mo') ? 'active':''" class="ui button">
                  Monthly
               </button>
               <button @click="activePeriod = 'an'" :class="(activePeriod == 'an') ? 'active':''" class="ui button">
                  Yearly (2 Months Free)
               </button>
            </div>
         </th>
         <th style="border-right: none;" v-for="plan in plans[activePeriod]" :key="plan.id">
            <span style="display: block; font-size: 22px;">{{plan.metadata.name}}</span>
            <span style="color: #222222; display: block; font-size: 40px; font-weight: 400; margin-top:20px;">
               {{plan.metadata.price}}
            </span>
            <span v-html="plan.metadata.desc" style="color: #222222; display: block; font-weight: 400; margin-top:15px;">
            </span>
            <span v-if="teamSize > 1" data-aos="zoom-in" style="color: #aaaaaa; display: block; font-style: italic; font-weight: 300; margin-top:15px;">
               ${{plan.metadata.priceLean}} x {{teamSize}} People = ${{plan.metadata.priceLean*teamSize}}/mo 
            </span>
         </th>
         </tr></thead>
         <tbody>
            <tr v-for="feature in features" :key="feature.id">

               <td data-label="Name">
                  <b>{{feature.name}}</b>
                  <span v-if="feature.desc" >
                     {{feature.desc}}
                  </span>
               </td>

               <td v-for="(desc, index) in feature.data" :key="index" data-label="Age">
                  <span v-html="desc"></span>
               </td>
            </tr>
            <tr class="warning">
               <td style="max-width: 300px;">
                  <div style="
                  display: flex; 
                  flex-direction: column;">
                     <div>
                        <b>Team size</b>
                     </div>
                     <div>
                        Select your team size.
                         <br><br>
                        <b>Note:</b> If you wish to downgrade your account please contact us at support@juphy.com
                     </div>
                  </div>
                  
               </td>
               <td colspan="2" style="padding: 3rem; word-wrap: break-word; word-break: break-all;">
                  <div style="
                  display: flex;
                  justify-content: center;
                   ">
                     <div> 
                        <button @click="adjustTeamSize(false)" :disabled="teamSize == 1" class="circular ui icon mini button">
                           <i class="icon minus"></i>
                        </button> 
                     </div>
                     <div style="font-size: 34px; padding: 0 1rem; font-weight: bold;"> 
                        {{teamSize}} <span v-show="teamSize == 1">Person</span> <span v-show="teamSize > 1">People</span>
                     </div>
                     <div> 
                        <button @click="adjustTeamSize(true)" class="circular ui icon mini button">
                           <i class="icon plus"></i>
                        </button> 
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td>
                  <div style="justify-content: left; align-items: center;" class="d-flex">
                     <div>
                        <input v-model="couponCode" v-on:keyup.enter="tryCoupon()" style="min-width: 300px; padding: 1rem 1rem 0.8rem 1rem; border: 1px solid #dedede; border-radius: 0.3rem; margin-left: 1rem;" type="text" placeholder="Discount code? Type and Press Enter" :disabled="couponActivated">
                     </div>
                  </div>
               
               </td>
               <td v-for="plan in plans[activePeriod]" :key="plan.id" data-label="Age">
                  <a href="#" @click="open(plan, teamSize)"  class="ui teal fluid button">Select {{plan.metadata.name}} Plan</a>
               </td>
            </tr>
         </tbody>
       </table>

   </div>
   </div>

      <div style="background:#ffffff;" class="row">
         <div  class="eight wide column">
            <div class="ui basic segment center aligned huge">
               <span style="font-weight: bold; font-size: 38px; line-height: 1.4;  color: #656565;">
               Juphy is rated as the “Easiest to Setup” on G2.
               </span>
            </div>
         </div>
         <div  class="eight wide column">
            <div class="ui basic segment center aligned">
            <img style="width: 300px; height: auto;" src="https://juphy.com/cdn-cgi/image/format=auto,fit=contain,w=920,quality=90/https://juphy.com/wp-content/uploads/2022/02/g2topbadges.jpg" alt="">
            </div>
         </div>
      </div>

      <div style="padding: 2rem 1rem;" class="row">
         <div class="eight wide column">

            <!-- Review 1 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://juphy.com/wp-content/uploads/2021/11/1550159247351.jpg" 
                        >
                  </div>
                  <div class="right">
                        <div style="font-size: 16px;" class="name">
                           <strong>
                              Ankit Singla
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Founder of MasterBlogging
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “It's such a time saver. I can easily manage all my social profiles in one place and I never miss a single message!”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        >
                  </div>
               </div>
            </div>
            <!-- Review 1 END -->

            <!-- Review 3 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://images.g2crowd.com/uploads/avatar/image/384261/thumb_square_22b2a09fdf3e20d40706bf7a0ebb18ca.jpeg" 
                        >
                  </div>
                  <div class="right">
                        <div class="name">
                           <strong>
                              Rafael
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Marketing Director
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “I love that I can view and manage all comments and messages from all of my social channels including app stores.”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        >
                  </div>
               </div>
            </div>
            <!-- Review 3 END -->

         </div>
         <div class="eight wide column">
            <!-- Review 2 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://lh3.googleusercontent.com/a-/AOh14GiaFZJbJPSGJA5ZJ1S3tjIdPra8BzpM055uL_xfOq8=s96-c" 
                        >
                  </div>
                  <div class="right">
                        <div class="name">
                           <strong>
                              Andrew L.
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Founder and CEO
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “Juphy is a fast, effective and efficient way to collate feedback and messages from multiple channels. This allows me to quickly serve my clients and maintain credibility as a proactive business with my clients..”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        >
                  </div>
               </div>
            </div>
            <!-- Review 2 END -->
            <!-- Review 4 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://images.g2crowd.com/uploads/avatar/image/325128/thumb_square_58838f9b7a876b1c8a7fcafa499fa099.jpeg" 
                        >
                  </div>
                  <div class="right">
                        <div class="name">
                           <strong>
                              Fabrizio
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Founder of digitalfastmind.com
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “Saving time by unifing all the reviews and comments from different platforms in one place.”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        >
                  </div>
               </div>
            </div>
            <!-- Review 4 END -->
         </div>
      </div>


         <div style="padding: 2rem 1rem; background: white;" class="row">
         <div class="sixteen wide column">
            <h2>Frequently Asked Questions</h2>
            <div class="ui basic large segment">
               <h3>What's your refund policy?</h3>
               <p>Juphy has a 30 day money-back guarantee! If you would like a refund within the first 30 days, please email support@juphy.com</p>
            </div>
            <div class="ui basic large segment">
               <h3>Which payment processor do you use?</h3>
               <p>We're partnered with Stripe to provide you the most secure payment experience.</p>
               <img style="width: 120px; height: auto;" src="https://cdn.brandfolder.io/KGT2DTA4/at/rvgw5pc69nhv9wkh7rw8ckv/Powered_by_Stripe_-_blurple.svg" alt="">
            </div>
            <div class="ui basic large segment">
               <h3>What happens if I add more team members?</h3>
               <p>If your team is growing, let us know at support@juphy.com and we will adjust your payment accordingly.</p>
            </div>
         </div>
         </div>
      </div>

</template>


<style scoped>

      .d-flex{
         display: flex;
      }

      .modalWrapper {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         z-index: 99999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
      .modalWrapper div {
         z-index: 99999;
      }
      .modal {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         background: rgba(41, 50, 84, 0.738) none repeat scroll 0% 0%; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }

      .ui.basic.active.button, .ui.basic.buttons .active.button {
         background: rgba(0,0,0,.05) !important;
         -webkit-box-shadow: '' !important;
         box-shadow: 2px 2px 15px gray !important;
         color: rgba(0,0,0,.95) !important;
         }
</style>





// WEBPACK FOOTER //
// src/components/dashboard/UpgradeV2.vue